0// Configuration variables
var aph_embedPageLink = window.location + "";
var aph_embedShowHints = false;
var aph_embedExampleType = "";
var aph_embedExampleMargin = "10";
var aph_embedExampleOffset = "200";
var aph_embedExampleWidth = "70";

// Check window width and set example type
if (window.innerWidth > 750) {
    aph_embedShowHints = true;
    if (aph_embedPageLink.indexOf("unisex-skull-kettlebell-t-shirt") > -1) {
        aph_embedExampleType = "single";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "236";
    } else if (aph_embedPageLink.indexOf("donut-quit-womens-t-shirt") > -1) {
        aph_embedExampleType = "multi";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "236";
    } else if (aph_embedPageLink.indexOf("burgers-burpees-unisex-t-shirt") > -1) {
        aph_embedExampleType = "counter";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "236";
    } else if (aph_embedPageLink.indexOf("good-wod-unisex-t-shirt") > -1) {
        aph_embedExampleType = "shipping";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "236";
    } else if (aph_embedPageLink.indexOf("may-your-coffee-be-strong-and-your-babys-naps-be-long-unisex-t-shirt") > -1) {
        aph_embedExampleType = "cross";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "240";
    } else if (aph_embedPageLink.indexOf("i-got-a-6am-toddler-unisex-t-shirt") > -1) {
        aph_embedExampleType = "cross";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "280";
    } else if (aph_embedPageLink.indexOf("skull-kettlebell-unisex-t-shirt") > -1) {
        aph_embedExampleType = "cross";
        aph_embedExampleMargin = "20";
        aph_embedExampleOffset = "353";
    } else {
        aph_embedShowHints = false;
    }
}

$(document).ready(function() {
    if (aph_embedShowHints) {
        var ImgSrc = "https://cdn.shopify.com/s/files/1/0437/5419/3050/files/arrow-right-down.png?v=1632225732";
        var htmlString = createStyles();
        htmlString += createHtmlContent(ImgSrc);
        
        $(htmlString).appendTo("body");
        initializeExample(ImgSrc);
    }
});

function createStyles() {
    return `<style>
        .aphEmbedSeeExampleHold {
            float: left;
            width: 450px;
            position: absolute;
            top: ${aph_embedExampleOffset}px;
            left: 300px;
            display: none;
            z-index: 200;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
        }
        .aphEmbedSeeExampleHold img {
            float: left;
            width: 100px;
            position: relative;
            top: 80px;
            left: 97px;
             z-index: 200;
        }
        .aphEmbedSeeExampleCont {
            float: left;
            width: 340px;
            margin-top: ${aph_embedExampleMargin}px;
            margin-left: -2px;
            background-color: #272939;
            padding: 30px 0 15px 0;
            border-radius: 150px;
            z-index: 200;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
        .aphEmbedSeeExampleContIn {
            float: left;
            width: ${aph_embedExampleWidth}%;
            color: #cecece;
            position: relative;
            left: 15%;
            font-size: 1.4rem;
        }
        .aphEmbedSeeExampleDismiss {
            float: left;
            width: 100%;
            padding: 5px 0;
            text-align: center;
        }
        .aphEmbedSeeExampleDismiss span {
            float: left;
        }
        .aphEmbedSeeExampleDismiss a {
            color: #e7c656;
        }
        .aphEmbedSeeExampleDismiss a:hover {
            text-decoration: underline;
        }
        .aphEmbedSeeExampleDismissMiddle {
            padding: 0 15px;
            color: #7a6b43;
            text-align: center;
        }
    </style>`;
}

function getExampleText() {
    switch(aph_embedExampleType) {
        case "single":
            return "Display a customizable announcement banner with adjustable position, styling, and design elements to match your store.";
        case "multi":
            return "Display multiple rotating messages on the same banner. You can add as many messages as you want, and customize everything to match your store design.";
        case "counter":
            return "Display announcements and offers with a countdown timer. You can easily customize everything such as timer settings, position, colors, font, and icon to match your store design.";
        case "shipping":
            return "Display a free shipping offer that will be updated automatically according to the cart value. To try it, add a product to cart on this page.";
        case "email":
            return "Display an expandable email signup form. You can easily customize style, and integrate it with your favorite email marketing app such as Mailchimp & Klaviyo.";
        case "cross":
            return "Boost sales by offering cross-sell items as product add-ons or \"frequently bought together\" bundles.";
        default:
            return "";
    }
}

function createHtmlContent(ImgSrc) {
    return `
        <div class='aphEmbedSeeExampleHold'>
            <span class='aphEmbedSeeExampleCont'>
                <span class='aphEmbedSeeExampleContIn'>
                    ${getExampleText()}
                    <span class='aphEmbedSeeExampleDismiss'>
                        <span class='aphEmbedSeeExampleDismissLeft'>
                            <a href='https://app-hero.myshopify.com/'>More examples</a>
                        </span>
                        <span class='aphEmbedSeeExampleDismissMiddle'>|</span>
                        <span class='aphEmbedSeeExampleDismissRight'>
                            <a href='javascript:void(0);' onclick='aph_embedDismissHint(this);'>Dismiss</a>
                        </span>
                    </span>
                </span>
                <img src='${ImgSrc}' />
            </span>
        </div>
    `;
}

function initializeExample(ImgSrc) {
    var newImg = new Image();
    newImg.onload = function() {
        setTimeout(function() {
            var tmpOffset = (($(window).width() - $(".aphEmbedSeeExampleHold").innerWidth()) / 2) - 60; // Subtract 200px
            $(".aphEmbedSeeExampleHold").css({
                display: "block",
                left: tmpOffset + "px",
                opacity: 0
            }).delay(100).animate({ opacity: 1 }, 300);
        }, 2000);
    };
    newImg.src = ImgSrc;
}

function aph_embedDismissHint() {
    $(".aphEmbedSeeExampleHold").css({
        display: "none"
    });
}